export default __webpack_public_path__ + "static/media/include_8_male@2x.ea7de56c.jpg";